import styled from 'styled-components';

export const Container = styled.div`
  .archived-table th {
    font-weight: 600;
    color: ${(props) => props.theme.$gray700};
    border-top: 0;
    white-space: nowrap;
  }

  .archived-table td {
    vertical-align: middle;
  }

  .archived-orgao {
    max-width: 280px;
  }

  .archived-object {
    max-width: 380px;
  }

  @media print {
    .table-responsive {
      overflow: visible;
    }

    .archived-orgao,
    .archived-object {
      max-width: none;
    }

    .archived-orgao .text-truncate {
      overflow: visible;
      white-space: normal;
    }

    .btn-long-text {
      display: none;
    }
  }
`;
